<template>
    <div class="row1">
        <select class="input_s" style="width: 130px;" v-model="filter.filterkey">
            <option
                v-for="(key, index) in filterkeys" :key="index" :value=key.value>
                {{ key.title }}
            </option>
        </select>
        <div v-if="!isModifierRelatedFilter">
            <input class="input_s" style="width: 240px; margin-left: 8px;" type="text" :placeholder="$t('popup_reservation_history.placeholder_search')"
                   v-model="filter.keyword" @keydown.enter="action_Search">
            <button class="input_s" style="margin-left: 8px;" @click="action_Search">{{ $t('popup_reservation_history.button_search') }}</button>
        </div>
        <div class="canceller_wrap" v-if="isModifierRelatedFilter">
            <label class="check_wrap">
                <input type="checkbox" :checked="filter.userTypes.includes(2000)" @change="action_SelectUserType(2000)">
                <span class="checkmark"></span>
                병원
            </label>
            <label class="check_wrap">
                <input type="checkbox" :checked="filter.userTypes.includes(3000)" @change="action_SelectUserType(3000)">
                <span class="checkmark"></span>
                애프터닥
            </label>
            <label class="check_wrap">
                <input type="checkbox" :checked="filter.userTypes.includes(1000)" @change="action_SelectUserType(1000)">
                <span class="checkmark"></span>
                고객
            </label>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
export default {
    props: {
        value: Object,
    },
    data() {
        return {
            enum_Key: {
                name: 'userName',
                group: 'groupTitle',
                column: 'columnTitle',
                writer: 'writerName'
            },

            filter: {
                filterkey: '',
                keyword: '',
                userTypes: [],
                key: '',
                way: ''
            }
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function (newValue) {
                if (newValue == undefined) { return }
                let f = deepCopy(newValue)
                if (f.hospitalID == undefined) { f.hospitalID = this.hospital.selectedHospital._id }
                if (f.filterkey == undefined) { f.filterkey = this.enum_Key.name }
                if (f.keyword == undefined) { f.keyword = '' }
                if (f.userTypes == undefined) { f.userTypes = [1000, 2000, 3000] }
                if (f.key == undefined) { f.key = 'createdAt' }
                if (f.way == undefined) { f.way = -1 }
                this.filter = deepCopy(f)
            }
        },
    },
    computed: {
        filterkeys: function () {
            return [
                { value: this.enum_Key.name, title: this.$t('popup_reservation_history.label_name') },
                { value: this.enum_Key.group, title: this.$t('popup_reservation_history.label_group') },
                { value: this.enum_Key.column, title: this.$t('popup_reservation_history.label_staff') },
                { value: this.enum_Key.writer, title: this.$t('popup_reservation_history.label_modifier') }
            ]
        },
        isModifierRelatedFilter: function () {
            return this.filter.filterkey == this.enum_Key.writer
        }
    },
    methods: {
        action_Search() {
            this.$emit('search', this.filter)
        },
        action_SelectUserType(type) {
            let index = this.filter.userTypes.indexOf(type)
            if (index == -1) {
                this.filter.userTypes.push(type)
            } else {
                this.filter.userTypes.splice(index, 1)
            }
            this.action_Search()
        }
    },
}
</script>

<style scoped>
.canceller_wrap {
    display: flex;
    align-items: center;
    margin-left: 8px;
}
</style>